import { useMemo, useState } from 'react';
import { MobileLinesContext } from './MobileLinesContext';

const MobileLinesProvider = ({ children }: { children: React.ReactNode }) => {
    const [showOptionDataSharing, setOptionShowDataSharing] = useState(false);

    const value = useMemo(
        () => ({
            showOptionDataSharing,
            setOptionShowDataSharing,
        }),
        [showOptionDataSharing],
    );

    return <MobileLinesContext.Provider value={value}>{children}</MobileLinesContext.Provider>;
};

export default MobileLinesProvider;
